import React, { type ReactNode, useState } from 'react';
import { IconButton } from '@atlaskit/button/new';
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import Popup, { type ContentProps, type TriggerProps } from '@atlaskit/popup';
import { layers } from '@atlassian/jira-common-styles/src/main.tsx';
import ContentWrapper from './content-wrapper';

type InfoPopupProps = {
	label: string;
	content: ReactNode;
};

const InfoPopup = ({ label, content }: InfoPopupProps) => {
	const [isOpen, setIsOpen] = useState(false);

	const setClosed = () => setIsOpen(false);

	const toggleOpen = () => setIsOpen(!isOpen);

	const formattedContent = (_: ContentProps) => {
		return <ContentWrapper>{content}</ContentWrapper>;
	};

	const trigger = (triggerProps: TriggerProps) => {
		return (
			<IconButton
				{...triggerProps}
				onClick={toggleOpen}
				icon={EditorPanelIcon}
				appearance="subtle"
				label={label}
				spacing="compact"
			/>
		);
	};

	return (
		<>
			<Popup
				isOpen={isOpen}
				onClose={setClosed}
				shouldRenderToParent
				placement="right"
				zIndex={layers.tooltip}
				trigger={trigger}
				content={formattedContent}
			/>
		</>
	);
};

export default InfoPopup;
